module.exports = __webpack_public_path__ + "img/centennial-tic-resilience-quote1.4bd45ebf.svg";